export const PaginationMachineId = 'paginationMachine'

export const PaginationMachineStates = {
  initializePaginationMachineState: 'initializePaginationMachineState',
  getPaginationDataState: 'getPaginationDataState'
}

export const PaginationMachineEvents = {
  setCurrentPageNo: 'SET_CURRENT_PAGE_NO',
  getPaginationData: 'GET_PAGINATION_DATA'
}
